<div
    [id]="id"
    class="agpr-form-message"
    [style.marginBottom]="marginBottom + 'px'"
>
    <div class="agpr-form-message-container">
        <div class="agpr-form-message-iconContainer">
            <span class="agpr-form-message-icon fa-solid fa-circle-minus" aria-hidden="true"></span>
        </div>
        <div
            class="agpr-form-message-content"
        >
            <ng-content></ng-content>
        </div>
    </div>
</div>